module.exports = __webpack_public_path__ + "static/techstars-logo-3e920029c90cc059ab17fe5cf0453ebd.png";